import { NO_VALUE } from "@/constants";
import { useDrawer } from "@/hooks/use-drawer";
import { docExample } from "@/pages/contractor-profile/contractor/__mocks__/document";
import { getNormalizedFileName } from "@/utils";
import { SideDrawer } from "../side-drawer";
import { DefaultContent } from "../side-drawer/default-content";

export const DocumentPreviewDrawer = ({ doc }: { doc?: string | null }) => {
  const {
    drawerProps: { drawerIsOpen, drawerName },
    handleCloseDrawer,
  } = useDrawer();

  const _fileName = drawerName ? getNormalizedFileName(drawerName) : NO_VALUE;

  if (!doc) {
    return null;
  }

  return (
    <SideDrawer
      title={_fileName}
      isOpen={drawerIsOpen}
      onClose={handleCloseDrawer}
    >
      <DefaultContent doc={doc || docExample} />
    </SideDrawer>
  );
};
